import { render, staticRenderFns } from "./SerasaPF.vue?vue&type=template&id=2b6906bc"
import script from "./SerasaPF.vue?vue&type=script&lang=js"
export * from "./SerasaPF.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports